import * as sensorMap from "../../Mapping/sensorMap";
import * as _url from "../../lib/url";

function get_current_url(current_url) {
    if (current_url) return current_url;
    
    return window.location.href || '';
}

function get_current_page_type(current_page_type) {
    if (current_page_type) return current_page_type;
    
    let path_name = window.location.pathname || '';
    return sensorMap.sensor_router_type(path_name);
}

function get_previous_url(previous_url) {
    if(previous_url) return previous_url;

    return (typeof document !== 'undefined' && typeof document.referrer === 'string') ? document.referrer : '';
}

// function get_previous_url() {
//      return window.location.search.replace(/\?historyLocation=/, window.location.origin + "/") || '';
// }
 
function get_previous_page_type_new(previous_page_type_new) {
    if(previous_page_type_new) return previous_page_type_new;

    let path_name = get_previous_url() || '';
    return sensorMap.sensor_router_type(path_name);
}

// function get_previous_page_type_new() {
//     let path_name = window.location.search.replace(/\?historyLocation=/, window.location.origin + "/") || '';
//      return sensor.sensor_router_match(path_name);
// }
 
function get_sign_up_method(sign_up_method) {
    if(sign_up_method) return sign_up_method;

    if (_url.urlGetParams(window.location, "state") == "QQ") return "qq";
    if (_url.urlGetParams( window.location, "state") == "WEIBO") return "weibo";
    if (_url.urlGetParams( window.location, "state") == "WECHAT") return "wechat";
 
    return '';
} 

function get_campaign_code( campaign_code ){
    const arr = (campaign_code && campaign_code.split(/intcmp=|kwrec=|prodlink=/)) || []
    return arr.length > 1 ? arr[arr.length - 1] : null
}
function get_banner_current_page_type() {

}

function get_os(os = ''){
    if(os) return os;
    return window.navigator.userAgent.indexOf("Windows") > 0 ? 'windows' : 'mac';
}
function get_environment_type(web = 'web'){
    let type = 'other'
    if (window.location.href.indexOf('www.sephora.cn') > 0) type='prod'
    if (window.location.href.indexOf('stage.sephora.cn') > 0) type='stage'
    if (window.location.href.indexOf('test.sephora.cn') > 0) type='test'

    return type
}
function get_banner_to_page_type(url){
    if(!url) return 'Other';
    if (url.search('/') < 0 ) return url
    return sensorMap.sensor_router_type(url);
}
export default {
    get_current_url,
    get_current_page_type,
    get_previous_url,
    get_previous_page_type_new,
    get_sign_up_method,
    get_campaign_code,
    get_banner_current_page_type,
    get_os,
    get_environment_type,
    get_banner_to_page_type
};


// WEBPACK FOOTER //
// ./common/Utils/Sensor/autoCompleteEnhancer.js